// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3oAFU","title":"InfoRow_title__2vT_P"};